import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefundType } from '../../enums/refund-type';
import { RefundTypePipe } from '../../pipes';

@Component({
  selector: 'app-refund-type',
  imports: [CommonModule, RefundTypePipe],
  templateUrl: './refund-type.component.html',
  styleUrl: './refund-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefundTypeComponent {
  public readonly type = input.required<RefundType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case RefundType.Full:
        return 'text-blue-600';

      case RefundType.Partial:
        return 'text-green-600';

      default:
        return '';
    }
  });
}
